<template>
  <div id="projects">
    <div style=" margin: 70px;">

      <div style=" margin: 40px;">
      <a href="#" class="previous round"  @click="moveToNextOrPrevRange(-1)">&#8249;</a>
      <a href="#" class="next round"      @click="moveToNextOrPrevRange(1)">&#8250;</a>
      <span id="renderRange" class="render-range">{{calender_date}}</span>
      </div>
      <hr>
     <calendar style="height: 800px;" ref="tuiCalendar"
        :schedules="events"
        :view="view"
        :taskView="taskView"
        :scheduleView="scheduleView"
        :theme="theme"
        :month="month"
        :disableDblClick="disableDblClick"
        :isReadOnly="isReadOnly"
        :template="template"
        :useCreationPopup="useCreationPopup"
        :useDetailPopup="useDetailPopup"
        @beforeCreateSchedule="onBeforeCreateSchedule"
        @clickSchedule="onClickSchedule"
    />
</div>

   <v-dialog v-model="event_dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{'events._Create_UpdateEvents_'|translate}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field :label="$t('events._Title_')" required
                   v-model="Eventdata.title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="$t('events._Location_')"  :hint="$t('events._Location_')"
                   v-model="Eventdata.location"></v-text-field>
                </v-flex>
                <v-flex xs12>

        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="Eventdata.start"
          :label="$t('events._Start_Date_')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="Eventdata.start" @input="menu = false"></v-date-picker>
        </v-menu>

               <!--   <v-datetime-picker
                        :label="$t('events._Start_Date_')"
                        v-model="Eventdata.start">
                </v-datetime-picker> -->
                </v-flex>
                     <v-flex xs12>
                   
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="Eventdata.end"
          :label="$t('events._End_Date_')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="Eventdata.end" @input="menu2 = false"></v-date-picker>
        </v-menu>

                 <!--   <v-datetime-picker
                       :label="$t('events._End_Date_')"
                        v-model="Eventdata.end">
                </v-datetime-picker> -->
                </v-flex>
                      <v-flex xs12>
                  <v-textarea
                   :label="$t('events._Description_')"
                    persistent-hint
                    required
                    v-model="Eventdata.body"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <small>{{'events._req_field_'|translate}}</small>
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="event_update" color="blue darken-1" flat @click="update_event(Eventdata)">{{'events._Update_'|translate}}</v-btn>
             <v-btn v-else color="blue darken-1" flat @click="create_event(Eventdata)">{{'events._Create_'|translate}}</v-btn>
             <v-btn v-if="event_update" color="blue darken-1" flat @click="delete_event(Eventdata)">{{'events._Delete_'|translate}}</v-btn>
            <v-btn color="blue darken-1" flat @click="close()">{{'events._Close_'|translate}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>
<script>
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import 'tui-calendar/dist/tui-calendar.css'
import { Calendar } from '@toast-ui/vue-calendar'
export default {
  name: "widget-events",
   components: {
        'calendar': Calendar
    },
   computed: {
    events(){
    
      let events =  this.$store.getters.events;
        this.loading=false
      return events;
    }
  },
    watch: {
   events(){
    
      let events =  this.$store.getters.events;
       this.loading=false
      return events;
    }
  },
  data() {
    return {
       menu: false,
      modal: false,
      menu2: false,
      calender_date:'',
       event_dialog: false,
       datetime:'',
       event_update:false,
       event_create:false,
       Eventdata:{
                id:'',
                calendarId:'1',
                category:'allday',
                created_by:'',
                created_by_id:'', 
                body:'',
                end:"",
                start:"",
                title:'',
                location:''
       },
            view: 'month',
            taskView: false,
            scheduleView: ['allday', 'time'],
            theme: {
                'month.dayname.height': '30px',
                'month.dayname.borderLeft': '1px solid #ff0000',
                'month.dayname.textAlign': 'center',
                'week.today.color': '#333',
                'week.daygridLeft.width': '100px',
                'week.timegridLeft.width': '100px'
            },
            month: {
              daynames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              startDayOfWeek: 1,
             // narrowWeekend: true
            },
            disableDblClick: true,
            isReadOnly: false,
            template: {
             milestone: function(schedule) {
            return '<span style="color:red;"><i class="fa fa-flag"></i> ' + schedule.title + '</span>';
        },
        milestoneTitle: function() {
            return 'Milestone';
        },
        task: function(schedule) {
            return '&nbsp;&nbsp;#' + schedule.title;
        },
        taskTitle: function() {
            return '<label><input type="checkbox" />Task</label>';
        },
        allday: function(schedule) {
            return schedule.title + ' <i class="fa fa-refresh"></i>';
        },
        alldayTitle: function() {
            return 'All Day';
        },
        time: function(schedule) {
            return schedule.title + ' <i class="fa fa-refresh"></i>' + schedule.start;
        }
            },
            useCreationPopup: false,
            useDetailPopup: false,
      created_by_id:"",
      created_by:"",
    };
  },
    created() {  
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
   
  },
  mounted() {
  //  this.FetchProjects();
    var date = this.$refs.tuiCalendar.invoke('getDateRangeEnd').toUTCString() ;
    this.calender_date =this.formatDate(date)
  },
  methods: {
     formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth()),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month].join('.');
},
     moveToNextOrPrevRange(val) {
    var date ='';
    if (val === -1) {
      date = this.$refs.tuiCalendar.invoke('getDateRangeEnd').toUTCString() ;
       this.$refs.tuiCalendar.invoke('prev');
         this.calender_date =this.formatDate(date)
       // calendar.prev();
    } else if (val === 1) {
      date = this.$refs.tuiCalendar.invoke('getDateRangeEnd').toUTCString();
      this.$refs.tuiCalendar.invoke('next');
      this.calender_date =this.formatDate(date)
        console.log(date); 
       // calendar.next();
    }
},

    update_event(e){
     db.collection("Events")
        .doc(e.id)
        .update({
                description:e.body,
                end_date:new Date(e.end+"T12:00:00Z"),
                start_date:new Date(e.start+"T12:00:00Z"),
                title:e.title,
                location:e.location   
        })
        .then(() => {
           
            this.event_dialog=false;
            this.event_create=false;
            this.$store.dispatch('fetchEvents')
        })
        .catch(error => {
          console.error("Error update/add events: ", error);
        });
      

    },
    create_event(e){
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
      const that = this;
      const memberRef = db.collection("Events").doc();
      const refKey = memberRef.id;
      var event_id = refKey;
    
      memberRef
        .set({
                id:event_id,
                calendarId:'1',
                category:'allday',
                bgColor:color,
                dragBgColor :color,
                created_by:this.created_by,
                created_by_id:this.created_by_id, 
                description:e.body,
                end_date:new Date(e.end+"T12:00:00Z"),
                start_date:new Date(e.start+"T12:00:00Z"),
                title:e.title,
                location:e.location
        })
        .then(() => {
            this.$store.dispatch('fetchEvents')
            this.event_dialog=false
            this.event_update=false
        })
        .catch(error => {
          console.error("Error adding event: ", error);
        });


    },
    delete_event(e){
      console.log(e.id)
      if (confirm(this.$t('events._confirm_delete_'))) {
        db.collection("Events")
          .doc(e.id)
          .delete()
           .then(() => {
            //alert(`Cette event a été suprimé`);
            this.$store.dispatch('fetchEvents')
            this.event_dialog=false
        })
        
      }
    },
    close() {
                 this.Eventdata.id=''
                 this.Eventdata.category=''
                 this.Eventdata.body=''
                 this.Eventdata.end=""
                 this.Eventdata.start=""
                 this.Eventdata.title=''
                 this.Eventdata.location=''
                 this.event_dialog=false
                 this.event_update=false
          },
        onBeforeCreateSchedule(e) {
          console.log('beforeCreateSchedule', e.end._date, e.end._date.toUTCString());
         
           let formatted_date_end =e.end._date.getFullYear() + "-" + ("0" + (e.end._date.getMonth() + 1)).slice(-2) + "-" +("0" + e.end._date.getDate()).slice(-2)
           let formatted_date_start =e.start._date.getFullYear() + "-" + ("0" + (e.start._date.getMonth() + 1)).slice(-2) + "-" +("0" + e.start._date.getDate()).slice(-2)
             
            // implement your code
                 this.Eventdata.end= formatted_date_end
                 this.Eventdata.start=formatted_date_start
                 this.event_update=false;
                 this.event_create=false;
                 this.event_dialog=true;
                 
            e.guide.clearGuideElement();
        }, 
        onClickSchedule(e) {
          let formatted_date_end =e.schedule.end._date.getFullYear() + "-" + ("0" + (e.schedule.end._date.getMonth() + 1)).slice(-2) + "-" +("0" + e.schedule.end._date.getDate()).slice(-2)
           let formatted_date_start =e.schedule.start._date.getFullYear() + "-" + ("0" + (e.schedule.start._date.getMonth() + 1)).slice(-2) + "-" +("0" + e.schedule.start._date.getDate()).slice(-2)
                
                this.event_update=true;
                 this.event_create=false;
                 console.log('clickSchedule',e.schedule.end._date);
                 this.Eventdata.id=e.schedule.id
                 this.Eventdata.category=e.schedule.id
                 this.Eventdata.body=e.schedule.body
                 this.Eventdata.end=formatted_date_end
                 this.Eventdata.start= formatted_date_start
                 this.Eventdata.title=e.schedule.title
                 this.Eventdata.location=e.schedule.location
                 this.event_dialog=true;
                 

                 
            // implement your code
        },
   
    editItem(item) {
      this.selected = item;
      this.$router.push({
        name: "components/modifiers-editmedia",
        params: {
          media_id: item.id
        }
      });
    },


  }
};
</script>
<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
a {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}

a:hover {
  background-color: #ddd;
  color: black;
}

.previous {
  background-color: #f1f1f1;
  color: black;
}

.next {
  color: white;  background-color: #135de6;

}

.round {
  border-radius: 50%;
}
#renderRange {

  padding-left: 12px;
font-size: 19px;
vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/widgets/Events.vue